// extracted by mini-css-extract-plugin
export default {"situation":"situation_situation__qSBA5","selected":"situation_selected__a3j8a","completed":"situation_completed__bMP0O"};